// extracted by mini-css-extract-plugin
export default {"fields":"chy_MN","gaps":"MRWc6J","time":"DAGncy","mobile":"wOssus"};